"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.mapOutputOperStatusFromInt = exports.mapInputOperStatusFromInt = exports.outputOperStatusValues = exports.inputOperStatusValues = exports.roleLevels = exports.DATE_FORMAT_LONG = exports.DATE_FORMAT_SHORT = exports.endOfDayMaxNowUTC = exports.endOfDayUTC = exports.startOfDayUTC = exports.dateToYearMonthDayMaxNowString = exports.dateToYearMonthDayString = exports.startOfMonthUTC = exports.ElementaryStreamTypeName = exports.isOutput = exports.getEntityTypeName = exports.validate = exports.validateUsername = exports.REGEX_ALPHANUMERIC = exports.validatePassword = exports.getTransferredString = exports.getProductName = exports.getInputOperState = exports.isUdpOutputOrUnixOutput1m = exports.MIN_CONTROL_TRAFFIC_BITRATE = exports.MIN_VIDEO_BITRATE_BPS = exports.MIN_AUDIO_BITRATE_BPS = exports.METRICS_FRESHNESS_LIMIT_SECONDS = void 0;
exports.getMinimumAcceptableInputBitrateBps = getMinimumAcceptableInputBitrateBps;
exports.outputStatus = outputStatus;
exports.inputStatus = inputStatus;
exports.getOutputOperState = getOutputOperState;
exports.isAnyRistServerInputMetrics = isAnyRistServerInputMetrics;
exports.isRistServerEgressMetrics = isRistServerEgressMetrics;
exports.isRistServerEgressMetricType = isRistServerEgressMetricType;
exports.getMetricTypeForOutput = getMetricTypeForOutput;
exports.isRistInputMetrics = isRistInputMetrics;
exports.isRistOutputMetrics = isRistOutputMetrics;
exports.isUnixInputMetrics = isUnixInputMetrics;
exports.isUdpInputMetrics = isUdpInputMetrics;
exports.isOutputMetricsWithPacketsLost = isOutputMetricsWithPacketsLost;
exports.isUdpOutputMetrics = isUdpOutputMetrics;
exports.isUnixOutputMetrics = isUnixOutputMetrics;
exports.isUdpOutputOrUnixOutputMetrics = isUdpOutputOrUnixOutputMetrics;
exports.isRtpInputMetrics = isRtpInputMetrics;
exports.isMptsMetrics = isMptsMetrics;
exports.isTranscodeStreamMetrics = isTranscodeStreamMetrics;
exports.isRtpOutputMetrics = isRtpOutputMetrics;
exports.isRistSimpleProfileInputMetrics = isRistSimpleProfileInputMetrics;
exports.isRistSimpleProfileOutputMetrics = isRistSimpleProfileOutputMetrics;
exports.isZixiInputMetrics = isZixiInputMetrics;
exports.isZixiOutputMetric = isZixiOutputMetric;
exports.isSrtInputMetric = isSrtInputMetric;
exports.isSrtOutputMetric = isSrtOutputMetric;
exports.isRtmpInputMetric = isRtmpInputMetric;
exports.isRtmpOutputMetric = isRtmpOutputMetric;
exports.isRistServerChannelMetrics = isRistServerChannelMetrics;
exports.isRistServerPortMode = isRistServerPortMode;
exports.isMatroxPortMode = isMatroxPortMode;
exports.isIpPortMode = isIpPortMode;
exports.isIpPort = isIpPort;
exports.isVideonPortMode = isVideonPortMode;
exports.isVideonPort = isVideonPort;
exports.isComprimatoPortMode = isComprimatoPortMode;
exports.getActiveChannelOnAppliance = getActiveChannelOnAppliance;
exports.ageSeconds = ageSeconds;
exports.notUndefined = notUndefined;
exports.notUndefinedOrNull = notUndefinedOrNull;
exports.getFormattedTransportStreamContent = getFormattedTransportStreamContent;
exports.getInputPidsOnInputAppliance = getInputPidsOnInputAppliance;
exports.getTransportStreamContentInfo = getTransportStreamContentInfo;
exports.tsInfoServiceName = tsInfoServiceName;
exports.audioFormatFromTransportStream = audioFormatFromTransportStream;
exports.videoFormatFromTransportStream = videoFormatFromTransportStream;
exports.formatBitrate = formatBitrate;
exports.getApplianceStatus = getApplianceStatus;
exports.formatGraphNodeId = formatGraphNodeId;
exports.splitGraphNodeId = splitGraphNodeId;
exports.isMpts = isMpts;
exports.getVideoCodec = getVideoCodec;
exports.getAudioCodec = getAudioCodec;
exports.endOfMonthUTC = endOfMonthUTC;
exports.addMonthUTC = addMonthUTC;
exports.prettyFormatError = prettyFormatError;
exports.isIpcPortMode = isIpcPortMode;
exports.omit = omit;
exports.getRoleLevel = getRoleLevel;
exports.maxRole = maxRole;
exports.applyCodecRestrictions = applyCodecRestrictions;
exports.isNameValueOption = isNameValueOption;
exports.supportsUnixSockets = supportsUnixSockets;
exports.formatOutputStreamContents = formatOutputStreamContents;
exports.productIdFromEdgeProduct = productIdFromEdgeProduct;
exports.inputOperStatusToInt = inputOperStatusToInt;
exports.inputOperStatusFromInt = inputOperStatusFromInt;
exports.outputOperStatusToInt = outputOperStatusToInt;
exports.outputOperStatusFromInt = outputOperStatusFromInt;
const constants_1 = require("../../constants");
const types_1 = require("./types");
const errors_1 = require("../../errors");
const rist_1 = require("../../rist");
const serialization_1 = require("../../serialization");
const buildInfoUtils_1 = require("../../buildInfoUtils");
const applianceTypeUtil_1 = require("../../applianceTypeUtil");
exports.METRICS_FRESHNESS_LIMIT_SECONDS = 30;
exports.MIN_AUDIO_BITRATE_BPS = 1_000 * 8; // 8 Kbps
exports.MIN_VIDEO_BITRATE_BPS = 100_000; // 0.1 Mbps
// Note on value 5.5kbps:
// Inspecting an inhibited/standy RIST-stream in the service overview suggests that ~11kbps is normal bitrate for traffic only so I simply halved that.
// TODO: Ask stream team for an appropriate value
exports.MIN_CONTROL_TRAFFIC_BITRATE = 5_500;
function getMinimumAcceptableInputBitrateBps(tsInfo) {
    const pids = tsInfo?.pids;
    if (!pids) {
        // Not a TS-stream?
        return exports.MIN_VIDEO_BITRATE_BPS;
    }
    const { hasMpegTsAudio, hasMpegTsVideo } = getTransportStreamContentInfo(pids);
    if (hasMpegTsAudio && hasMpegTsVideo) {
        return exports.MIN_VIDEO_BITRATE_BPS;
    }
    if (hasMpegTsVideo) {
        return exports.MIN_VIDEO_BITRATE_BPS;
    }
    if (hasMpegTsAudio) {
        return exports.MIN_AUDIO_BITRATE_BPS;
    }
    // No audio or video found in the TS-stream - only private data? We have no idea what is acceptable. Return MIN_VIDEO_BITRATE_BPS for backwards compatibility.
    return exports.MIN_VIDEO_BITRATE_BPS;
}
const isUdpOutputOrUnixOutput1m = (ristMetrics) => (ristMetrics.type === 'udpOutput' || ristMetrics.type === 'unixOutput') && ristMetrics.window === types_1.MetricWindow.m1;
exports.isUdpOutputOrUnixOutput1m = isUdpOutputOrUnixOutput1m;
function outputStatus(state, title) {
    return {
        state,
        title,
    };
}
function inputStatus(state, title) {
    return {
        state,
        title,
    };
}
function getOutputOperState(o) {
    return o.health || { state: types_1.OutputOperStatus.metricsMissing, title: 'Health status missing' };
}
function isAnyRistServerInputMetrics(ristMetrics) {
    return (ristMetrics.type === types_1.RistMetricType.ristInput ||
        ristMetrics.type === types_1.RistMetricType.udpInput ||
        ristMetrics.type === types_1.RistMetricType.unixInput ||
        ristMetrics.type === types_1.RistMetricType.rtpInput ||
        ristMetrics.type === types_1.RistSimpleProfileMetricType.ristSimpleInput);
}
function isRistServerEgressMetrics(m) {
    return m.window === types_1.MetricWindow.s10 && isRistServerEgressMetricType(m.type) && !!m.isEgress;
}
function isRistServerEgressMetricType(type) {
    const ristServerEgressMetricTypes = [
        types_1.RistMetricType.udpOutput,
        types_1.RistMetricType.unixOutput,
        types_1.RistMetricType.rtpOutput,
        types_1.RistSimpleProfileMetricType.ristSimpleOutput,
    ];
    if (isMatroxMetricType(type) || isComprimatoMetricType(type)) {
        return false;
    }
    return ristServerEgressMetricTypes.includes(type);
}
function isComprimatoMetricType(type) {
    return type in types_1.ComprimatoMetricType;
}
function isMatroxMetricType(type) {
    return type in types_1.MatroxMetricType;
}
function getMetricTypeForOutput(outputPortMode, applianceType) {
    if ((0, applianceTypeUtil_1.isVaApplianceType)(applianceType)) {
        return types_1.RistMetricType.rtpOutput;
    }
    switch (outputPortMode) {
        case types_1.CoaxPortMode.asi:
            return types_1.RistMetricType.rtpOutput;
        case types_1.CoaxPortMode.sdi:
            return types_1.RistMetricType.rtpOutput;
        case types_1.IpPortMode.udp:
            return types_1.RistMetricType.udpOutput;
        case types_1.IpPortMode.rtp:
            return types_1.RistMetricType.rtpOutput;
        case types_1.IpPortMode.rist:
            return types_1.RistSimpleProfileMetricType.ristSimpleOutput;
        case types_1.IpPortMode.srt:
            return types_1.SrtMetricType.srtOutput;
        case types_1.IpPortMode.zixi:
            return types_1.ZixiMetricType.zixiOutput;
        case types_1.IpPortMode.rtmp:
            return types_1.RtmpMetricType.rtmpOutput;
        case types_1.MatroxPortMode.matroxSdi:
            return types_1.MatroxMetricType.matroxSdiOutput;
        case types_1.ComprimatoPortMode.comprimatoNdi:
            return types_1.ComprimatoMetricType.comprimatoNdiOutput;
        case types_1.ComprimatoPortMode.comprimatoSdi:
            return types_1.ComprimatoMetricType.comprimatoSdiOutput;
        case types_1.IpcPortMode.unix:
            return types_1.RistMetricType.unixOutput;
    }
}
function isRistInputMetrics(m) {
    return m.type === types_1.RistMetricType.ristInput;
}
function isRistOutputMetrics(m) {
    return m.type === types_1.RistMetricType.ristOutput;
}
function isUnixInputMetrics(m) {
    return m.type === types_1.RistMetricType.unixInput;
}
function isUdpInputMetrics(m) {
    return m.type === types_1.RistMetricType.udpInput;
}
function isOutputMetricsWithPacketsLost(m) {
    return isUdpOutputMetrics(m) || isRtpOutputMetrics(m);
}
function isUdpOutputMetrics(m) {
    return m.type === types_1.RistMetricType.udpOutput;
}
function isUnixOutputMetrics(m) {
    return m.type === types_1.RistMetricType.unixOutput;
}
function isUdpOutputOrUnixOutputMetrics(m) {
    return isUdpOutputMetrics(m) || isUnixOutputMetrics(m);
}
function isRtpInputMetrics(m) {
    return m.type === types_1.RistMetricType.rtpInput;
}
function isMptsMetrics(m) {
    return m.type === types_1.MptsMetricType.mptsDemux;
}
function isTranscodeStreamMetrics(m) {
    return m.type === types_1.TrancodeStreamMetricType.transcodeStream;
}
function isRtpOutputMetrics(m) {
    return m.type === types_1.RistMetricType.rtpOutput;
}
function isRistSimpleProfileInputMetrics(m) {
    return m.type === types_1.RistSimpleProfileMetricType.ristSimpleInput;
}
function isRistSimpleProfileOutputMetrics(m) {
    return m.type === types_1.RistSimpleProfileMetricType.ristSimpleOutput;
}
function isZixiInputMetrics(m) {
    return m.type === types_1.ZixiMetricType.zixiInput;
}
function isZixiOutputMetric(m) {
    return m.type === types_1.ZixiMetricType.zixiOutput;
}
function isSrtInputMetric(m) {
    return m.type === types_1.SrtMetricType.srtInput;
}
function isSrtOutputMetric(m) {
    return m.type === types_1.SrtMetricType.srtOutput;
}
function isRtmpInputMetric(m) {
    return m.type === types_1.RtmpMetricType.rtmpInput;
}
function isRtmpOutputMetric(m) {
    return m.type === types_1.RtmpMetricType.rtmpOutput;
}
function isRistServerChannelMetrics(ristMetrics) {
    return ristMetrics.type === types_1.RistMetricType.channel;
}
function isRistServerPortMode(mode) {
    return mode === types_1.IpPortMode.udp || mode === types_1.IpPortMode.rtp || mode === types_1.IpPortMode.rist;
}
function isMatroxPortMode(portMode) {
    return portMode in types_1.MatroxPortMode;
}
function isIpPortMode(portMode) {
    return portMode in types_1.IpPortMode;
}
function isIpPort(inputPort) {
    return isIpPortMode(inputPort.mode);
}
function isVideonPortMode(portMode) {
    return portMode in types_1.VideonPortMode;
}
// There are currently no Videon output ports
function isVideonPort(port) {
    return isVideonPortMode(port.mode);
}
function isComprimatoPortMode(portMode) {
    return portMode in types_1.ComprimatoPortMode;
}
const getInputOperState = (input) => {
    return input.health || { state: types_1.InputOperStatus.metricsMissing, title: 'Health status missing' };
};
exports.getInputOperState = getInputOperState;
function getActiveChannelOnAppliance(applianceId, ristMetrics) {
    return (ristMetrics.find((m) => m.type === types_1.RistMetricType.channel && m.applianceId === applianceId && m.state === rist_1.ChannelState.activated)?.channelId ??
        // Backwards compatibility for appliances that don't have "channel.state" introduced in R3.15.0: Use first found channelId
        ristMetrics.find((m) => m.type === types_1.RistMetricType.channel && m.applianceId === applianceId)?.channelId);
}
function ageSeconds(d, dateNow = new Date()) {
    let date;
    if (typeof d === 'string') {
        date = Date.parse(d);
    }
    else {
        date = d.valueOf();
    }
    return Math.floor((dateNow.valueOf() - date) / 1000);
}
const getProductName = (type) => ({
    [types_1.ApplianceType.nimbraVAdocker]: 'Edge Connect+',
    [types_1.ApplianceType.nimbra410]: 'Nimbra 410',
    [types_1.ApplianceType.nimbra412]: 'Nimbra 412',
    [types_1.ApplianceType.nimbra414]: 'Nimbra 414',
    [types_1.ApplianceType.nimbra414b]: 'Nimbra 414b',
    [types_1.ApplianceType.nimbraVA225]: 'Nimbra VA 225',
    [types_1.ApplianceType.nimbraVA220]: 'Nimbra VA 220',
    [types_1.ApplianceType.edgeConnect]: 'Edge Connect',
    [types_1.ApplianceType.core]: 'Core node',
    [types_1.ApplianceType.thumb]: 'Core thumb',
    [types_1.ApplianceType.videon]: 'Videon',
    [types_1.ApplianceType.matroxMonarchEdgeE4_8Bit]: 'Monarch EDGE E4 (8 bit)',
    [types_1.ApplianceType.matroxMonarchEdgeE4_10Bit]: 'Monarch EDGE E4 (10 bit)',
    [types_1.ApplianceType.matroxMonarchEdgeD4]: 'Monarch EDGE D4',
    [types_1.ApplianceType.matroxMonarchEdgeS1]: 'Monarch EDGE S1',
    [types_1.ApplianceType.comprimato]: 'Comprimato',
    [types_1.ApplianceType.mediakindRx1]: 'Mediakind RX1',
    [types_1.ApplianceType.mediakindCe1]: 'Mediakind CE1',
}[type] || type);
exports.getProductName = getProductName;
const getTransferredString = (gbValue) => {
    if (gbValue === undefined) {
        return;
    }
    let measure = 'GB';
    let value = gbValue;
    if (Math.floor(gbValue) > 0) {
        value = gbValue.toFixed(2);
    }
    else {
        measure = 'MB';
        value = (gbValue * 1e3).toFixed(2);
        if (parseFloat(value) === 0) {
            value = `~${value}`;
        }
    }
    return `${value} ${measure}`;
};
exports.getTransferredString = getTransferredString;
const validatePassword = (value) => {
    const minPwdLength = 8;
    if (value.length > 0) {
        if (value.length < minPwdLength) {
            return `Password must contain at least ${minPwdLength} characters`;
        }
    }
    return undefined;
};
exports.validatePassword = validatePassword;
function emailIsValid(email) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email);
}
exports.REGEX_ALPHANUMERIC = /^[a-zA-Z0-9]*$/m;
const validateUsername = (value) => {
    if (!emailIsValid(value)) {
        return `Must be a valid email address`;
    }
    return undefined;
};
exports.validateUsername = validateUsername;
const validate = (fieldname, validationErrorInfo) => {
    if (validationErrorInfo) {
        throw new errors_1.InvalidParametersError(errors_1.ErrorCode.invalidParameters, [
            { name: fieldname, reason: validationErrorInfo },
        ]);
    }
};
exports.validate = validate;
const getEntityTypeName = (entityType) => {
    switch (entityType) {
        case types_1.EntityType.outputRecipientList:
            return 'output list';
        case types_1.EntityType.groupRecipientList:
            return 'group list';
        default:
            return entityType;
    }
};
exports.getEntityTypeName = getEntityTypeName;
function notUndefined(x) {
    return x !== undefined;
}
function notUndefinedOrNull(x) {
    return x !== undefined && x !== null;
}
function getFormattedTransportStreamContent(tsInfo) {
    if (!tsInfo) {
        return 'N/A';
    }
    const pids = tsInfo.pids;
    if (!pids) {
        return 'No pids';
    }
    const streamIsMpts = isMpts([tsInfo]);
    if (streamIsMpts) {
        return 'MPTS';
    }
    const { hasMpegTsAudio, hasMpegTsVideo } = getTransportStreamContentInfo(pids);
    if (hasMpegTsVideo) {
        return videoFormatFromTransportStream(pids);
    }
    else if (hasMpegTsAudio) {
        return audioFormatFromTransportStream(pids);
    }
    return `No audio/video`;
}
function getInputPidsOnInputAppliance(input, channelId) {
    if (!input || !channelId) {
        return [];
    }
    const inputApplianceIds = input.appliances?.map((appliance) => appliance.id);
    if (!inputApplianceIds) {
        return [];
    }
    const tsInfo = input.tsInfo;
    if (!tsInfo) {
        return [];
    }
    const inputApplianceTsInfo = tsInfo.find((tsInfo) => inputApplianceIds.includes(tsInfo.applianceId) && tsInfo.channelId === channelId);
    return inputApplianceTsInfo?.pids || [];
}
function getTransportStreamContentInfo(pids) {
    return {
        hasMpegTsAudio: pids.some((p) => p?.streamInfo?.audio !== undefined),
        hasMpegTsVideo: pids.some((p) => p?.streamInfo?.video !== undefined),
    };
}
function tsInfoServiceName(info) {
    const firstService = info?.services?.[0];
    const noInfo = 'no info';
    if (!firstService) {
        return noInfo;
    }
    return `${firstService.name || firstService.type?.description || noInfo}`;
}
function audioFormatFromTransportStream(tsPids) {
    // TODO: Handle MPTS - we currently extract the first found audio entry
    const audioPid = tsPids.find((p) => p?.streamInfo?.audio);
    if (!audioPid) {
        return 'No audio';
    }
    const audio = audioPid.streamInfo.audio;
    const sampleRate = audio.sampleRate ? `${audio.sampleRate / 1000}kHz ` : '';
    const codec = getFormattedElementaryStreamType(audioPid);
    return `${sampleRate}${codec}`;
}
function formattedRate(video) {
    if (!video.frameRate)
        return '';
    const framerate = video.frameRate;
    const fieldrate = framerate * 2;
    return (video.interlaced === 'yes' ? fieldrate : framerate).toFixed(2);
}
function videoFormatFromTransportStream(tsPids) {
    // TODO: Handle MPTS - we currently extract the first found video entry
    const videoPid = tsPids.find((p) => p?.streamInfo?.video);
    if (!videoPid) {
        return 'No video';
    }
    const video = videoPid.streamInfo.video;
    const videoSize = video.videoSize ? video.videoSize.vertical : '';
    const interlaced = video.interlaced ? (video.interlaced === 'yes' ? 'i' : 'p') : '?';
    const resolution = `${videoSize}${interlaced}`;
    const frameOrFieldrate = formattedRate(video);
    const codec = getFormattedElementaryStreamType(videoPid);
    return `${resolution}${frameOrFieldrate} ${codec}`;
}
const isOutput = (inputOrOutput) => {
    return (inputOrOutput.type === 'push-rist-output' ||
        inputOrOutput.type === 'rist-simple-output' ||
        inputOrOutput.type === 'srt-output' ||
        inputOrOutput.type === 'zixi-output' ||
        inputOrOutput.type === 'udp-output' ||
        inputOrOutput.type === 'rtp-output' ||
        inputOrOutput.type === 'rtmp-output');
};
exports.isOutput = isOutput;
function formatBitrate(bps) {
    if (typeof bps === 'string') {
        // eslint-disable-next-line no-param-reassign
        bps = parseInt(bps);
    }
    if (typeof bps !== 'number' || !Number.isFinite(bps)) {
        return 'N/A';
    }
    const units = [
        ['kbps', 0],
        ['Mbps', 2],
        ['Gbps', 3],
        ['Tbps', 3],
    ];
    const absBps = Math.max(bps, 0);
    const log = Math.floor(Math.log10(absBps));
    const size = Math.max(Math.floor(log / 3) - 1, 0);
    const [unit, decimals] = units[size];
    const val = absBps / Math.pow(10, (size + 1) * 3);
    const formattedVal = val.toFixed(decimals);
    return `${formattedVal} ${unit}`;
}
function getApplianceStatus(appliance, formatDistanceToNow) {
    const applianceOnlineThresholdSeconds = 15;
    if (!appliance.lastMessageAt) {
        return {
            title: `Never connected`,
            state: types_1.ApplianceConnectionState.neverConnected,
        };
    }
    if (ageSeconds(appliance.lastMessageAt) > applianceOnlineThresholdSeconds) {
        return {
            title: `Last seen ${formatDistanceToNow(appliance.lastMessageAt)} ago`,
            state: types_1.ApplianceConnectionState.missing,
        };
    }
    return {
        title: `Last seen less than ${applianceOnlineThresholdSeconds} seconds ago`,
        state: types_1.ApplianceConnectionState.connected,
    };
}
function formatGraphNodeId({ type, id }) {
    return `${type}::${id}`;
}
function splitGraphNodeId(nodeId) {
    const [type, id] = nodeId.split('::');
    return { type, id };
}
var ElementaryStreamTypeName;
(function (ElementaryStreamTypeName) {
    ElementaryStreamTypeName["h262"] = "h262";
    ElementaryStreamTypeName["mpeg1"] = "mpeg-1";
    ElementaryStreamTypeName["mpeg2"] = "mpeg-2";
    ElementaryStreamTypeName["adtsAac"] = "adts-aac";
    ElementaryStreamTypeName["h263"] = "h263";
    ElementaryStreamTypeName["h264"] = "h264";
    ElementaryStreamTypeName["j2k"] = "j2k";
    ElementaryStreamTypeName["h265"] = "h265";
    ElementaryStreamTypeName["jpegxs"] = "jpeg-xs";
    ElementaryStreamTypeName["ac3"] = "ac3";
    ElementaryStreamTypeName["eac3"] = "eac3";
})(ElementaryStreamTypeName || (exports.ElementaryStreamTypeName = ElementaryStreamTypeName = {}));
function isMpts(tsInfo) {
    return tsInfo?.some((tsInfo) => (tsInfo.services?.length || 1) > 1);
}
function getVideoCodec(tsInfo) {
    if (!tsInfo) {
        return null;
    }
    // note: channelId stores priority in highest bits
    const thumbTsInfo = tsInfo
        .filter((t) => t.applianceType === types_1.ApplianceType.thumb)
        .sort((a, b) => (a.channelId ?? 0) - (b.channelId ?? 0));
    const videoPid = thumbTsInfo[0]?.pids?.find((p) => p?.streamInfo?.video !== undefined);
    if (!videoPid) {
        return null;
    }
    return getElementaryStreamType(videoPid.streamInfo?.type?.value);
}
function getAudioCodec(tsInfo) {
    if (!tsInfo) {
        return null;
    }
    const audioPid = tsInfo[0]?.pids?.find((p) => p?.streamInfo?.audio !== undefined);
    if (!audioPid) {
        return null;
    }
    return getElementaryStreamType(audioPid.streamInfo?.type?.value);
}
function getFormattedElementaryStreamType(pid) {
    const streamTypeValue = pid.streamInfo?.type?.value;
    if (streamTypeValue) {
        const mappedStreamType = getElementaryStreamType(streamTypeValue);
        if (mappedStreamType !== null) {
            return mappedStreamType.toString();
        }
    }
    const pidDescription = pid.description;
    if (pidDescription) {
        return pidDescription;
    }
    if (streamTypeValue) {
        return `(${streamTypeValue})`;
    }
    return '?';
}
/**
 * https://en.wikipedia.org/wiki/Program-specific_information#Elementary_stream_types
 */
function getElementaryStreamType(streamType) {
    switch (streamType) {
        case 1:
            return ElementaryStreamTypeName.mpeg1; // Video
        case 2:
            return ElementaryStreamTypeName.h262;
        case 3:
            return ElementaryStreamTypeName.mpeg1; // Audio
        case 4:
            return ElementaryStreamTypeName.mpeg2; // Audio
        case 15:
            return ElementaryStreamTypeName.adtsAac; // Audio
        case 16:
            return ElementaryStreamTypeName.h263;
        case 27:
            return ElementaryStreamTypeName.h264;
        case 33:
            return ElementaryStreamTypeName.j2k;
        case 36:
            return ElementaryStreamTypeName.h265;
        case 50:
            return ElementaryStreamTypeName.jpegxs;
        case 129:
            return ElementaryStreamTypeName.ac3; // Audio
        case 132:
            return ElementaryStreamTypeName.eac3; // Audio
        case 135:
            return ElementaryStreamTypeName.eac3; // Audio
    }
    return null;
}
// return start of month in UTC
const startOfMonthUTC = (value) => {
    const month = value.getUTCMonth() + 1;
    const monthStr = month < 10 ? `0${month}` : `${month}`;
    return new Date(`${value.getUTCFullYear()}-${monthStr}-01T00:00:00.000Z`);
};
exports.startOfMonthUTC = startOfMonthUTC;
function endOfMonthUTC(d) {
    const endDate = new Date(d);
    endDate.setUTCDate(1);
    endDate.setUTCMonth(endDate.getUTCMonth() + 1);
    endDate.setUTCDate(0);
    endDate.setUTCHours(23, 59, 59, 999);
    return endDate;
}
function addMonthUTC(d, n = 1) {
    const addedMonth = new Date(d);
    const date = addedMonth.getUTCDate();
    addedMonth.setUTCDate(1);
    const nextMonth = addedMonth.getUTCMonth() + n;
    addedMonth.setUTCMonth(nextMonth);
    addedMonth.setUTCDate(Math.min(date, endOfMonthUTC(addedMonth).getUTCDate()));
    return addedMonth;
}
const dateToYearMonthDayString = (d) => {
    return d.toISOString().substring(0, 10);
};
exports.dateToYearMonthDayString = dateToYearMonthDayString;
const dateToYearMonthDayMaxNowString = (d) => {
    d = d.getTime() > Date.now() ? new Date() : d;
    return (0, exports.dateToYearMonthDayString)(d);
};
exports.dateToYearMonthDayMaxNowString = dateToYearMonthDayMaxNowString;
const startOfDayUTC = (d) => {
    return new Date((0, exports.dateToYearMonthDayString)(d));
};
exports.startOfDayUTC = startOfDayUTC;
const endOfDayUTC = (d) => {
    return new Date(`${(0, exports.dateToYearMonthDayString)(d)}T23:59:59.999Z`);
};
exports.endOfDayUTC = endOfDayUTC;
const endOfDayMaxNowUTC = (d) => {
    const endOfDay = (0, exports.endOfDayUTC)(d);
    return endOfDay.getTime() > Date.now() ? new Date() : endOfDay;
};
exports.endOfDayMaxNowUTC = endOfDayMaxNowUTC;
function prettyFormatError(e) {
    const str = e?.toString();
    if (str === '[object Object]') {
        return (0, serialization_1.tryStringify)(e);
    }
    return str;
}
function isIpcPortMode(portMode) {
    return portMode in types_1.IpcPortMode;
}
exports.DATE_FORMAT_SHORT = 'yyyy-MM-dd';
exports.DATE_FORMAT_LONG = 'yyyy-MM-dd HH:mm:ss';
function omit(t, ...omitKeys) {
    const o = { ...t };
    for (const k of omitKeys) {
        delete o[k];
    }
    return o;
}
exports.roleLevels = Object.freeze([types_1.Role.basic, types_1.Role.admin, types_1.Role.super]);
function getRoleLevel(role) {
    const index = exports.roleLevels.findIndex((r) => r === role);
    if (index === -1) {
        throw new Error(`Invalid role: ${role}`);
    }
    return index;
}
function maxRole(...roles) {
    if (roles.length === 0) {
        throw new Error(`maxRole expects at least one role as input`);
    }
    let maxRole = roles[0];
    for (const role of roles) {
        if (getRoleLevel(role) > getRoleLevel(maxRole)) {
            maxRole = role;
        }
    }
    return maxRole;
}
function applyCodecRestrictions(options, property, encoderSettings, restrictions) {
    // Yes, the typing here could be improved
    const opts = options || [];
    if (!Array.isArray(opts)) {
        return opts;
    }
    const propRestrictions = restrictions && restrictions[property];
    if (!propRestrictions) {
        return opts;
    }
    const determinant = propRestrictions.determinedBy;
    if (!(determinant in encoderSettings)) {
        return opts;
    }
    const determinantValue = encoderSettings[determinant];
    const mappedValues = propRestrictions.mapping[determinantValue];
    if (!Array.isArray(mappedValues)) {
        return opts;
    }
    return opts.filter((o) => {
        return mappedValues.includes(isNameValueOption(o) ? o.value : o);
    });
}
function isNameValueOption(v) {
    return typeof v === 'object' && typeof v['name'] === 'string' && 'value' in v;
}
function supportsUnixSockets(applianceVersion) {
    if (applianceVersion.dataSoftwareVersion === 'ci-690874508') {
        // For testing purpose, ci-690874508 is a master build > R3.13.0 and < R3.14.0
        return false;
    }
    return (0, buildInfoUtils_1.isReleaseGreaterThanOrEqualToVersion)('R3.14.0', applianceVersion.dataSoftwareVersion);
}
function formatOutputStreamContents({ ports, tsInfo }) {
    if (isMatroxPortMode(ports[0].mode)) {
        return formatFromMatroxOutputPort(ports[0]);
    }
    else {
        return getFormattedTransportStreamContent((tsInfo || [])[0]);
    }
}
function productIdFromEdgeProduct(edgeProduct) {
    switch (edgeProduct) {
        case types_1.EdgeProduct.loci:
            return constants_1.PRODUCTS.connectIt.id;
        case types_1.EdgeProduct.edge:
            return constants_1.PRODUCTS.nimbraEdge.id;
    }
}
function formatFromMatroxOutputPort(port) {
    return port.decoderSettings.outputSettings.resolution;
}
// This is how the status is stored in the database and the order used for sorting
exports.inputOperStatusValues = {
    allOk: 0,
    reducedRedundancy: 10,
    notConfigured: 20,
    metricsMissing: 30,
    tr101290Priority1Error: 40,
    transportError: 50,
    alarm: 60,
    inputError: 70,
};
// This is how the status is stored in the database and the order used for sorting
exports.outputOperStatusValues = {
    allOk: 0,
    reducedRedundancy: 10,
    notAcknowledged: 20,
    notConfigured: 30,
    metricsMissing: 40,
    inputError: 50,
    tr101290Priority1Error: 60,
    alarm: 70,
    outputError: 80,
};
exports.mapInputOperStatusFromInt = new Map(Object.entries(exports.inputOperStatusValues).map(([key, value]) => [value, key]));
exports.mapOutputOperStatusFromInt = new Map(Object.entries(exports.outputOperStatusValues).map(([key, value]) => [value, key]));
function inputOperStatusToInt(status) {
    return exports.inputOperStatusValues[status] ?? 80;
}
function inputOperStatusFromInt(status) {
    return exports.mapInputOperStatusFromInt.get(status) ?? types_1.InputOperStatus.inputError;
}
function outputOperStatusToInt(status) {
    return exports.outputOperStatusValues[status] ?? 80;
}
function outputOperStatusFromInt(status) {
    return exports.mapOutputOperStatusFromInt.get(status) ?? types_1.OutputOperStatus.outputError;
}
//# sourceMappingURL=data:application/json;base64,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